import { axiosInstance } from '../common/api';

export const createTask = (data) => {
  const url = `/task/add`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getTasks = () => {
  const url = `/task`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getAllTasksByProjectId = ({
  start,
  pageSize,
  projectId,
  filters,
  globalFilter,
  sorting,
  wantCompletedTask,
  forParent,
  assignedToMe,
}) => {
  let url = `/task/project/${projectId}?`;
  if (pageSize) url += `pageSize=${pageSize}&`;
  if (start) url += `start=${start}&`;
  if (filters) url += `filters=${filters}&`;
  if (globalFilter) url += `globalFilter=${globalFilter}&`;
  if (sorting) url += `sorting=${sorting}&`;
  if (wantCompletedTask) url += `wantCompletedTask=${wantCompletedTask}&`;
  if (forParent) url += `forParent="true"&`;
  if (assignedToMe) url += `assignedToMe=true&`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response.data))
      .catch((err) => reject(err));
  });
};

// export const getAllTasksByProjectId = (projectId) => {
//   const url = `/task/project/${projectId}`;
//   return new Promise((resolve, reject) => {
//     axiosInstance
//       .get(url)
//       .then((response) => resolve(response.data))
//       .catch((err) => reject(err));
//   });
// };

export const getAllFilteredTask = ({ pageNumber, pageSize, order, search, orderBy, projectId }) => {
  let url = `/task/all?`;
  if (orderBy) url += `orderBy=${orderBy}&`;
  if (order) url += `order=${order}&`;
  if (search) url += `search=${search}&`;
  if (pageSize) url += `pageSize=${pageSize}&`;
  if (pageNumber) url += `pageNumber=${pageNumber + 1}&`;
  if (projectId) url += `projectId=${projectId}&`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response.data))
      .catch((err) => reject(err));
  });
};

export const getMyTaskFilteredTask = ({ start, pageSize, filters, globalFilter, sorting, projectId, status }) => {
  let url = `/task/myTask?`;

  if (pageSize) url += `pageSize=${pageSize}&`;
  if (start) url += `start=${start}&`;
  if (filters) url += `filters=${filters}&`;
  if (globalFilter) url += `globalFilter=${globalFilter}&`;
  if (sorting) url += `sorting=${sorting}&`;
  if (projectId) url += `projectId=${projectId}&`;
  if (status) url += `status=${status}&`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateTask = (id, data) => {
  const url = `/task/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteTask = (id) => {
  const url = `/task/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const getTaskById = (id) => {
  const url = `/task/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const bulkUploadTask = (file) => {
  const url = `/task/bulk-upload`;

  // Create a FormData object to handle the file upload
  const formData = new FormData();
  formData.append('file', file);

  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getMyBoard = () => {
  const url = `/task/board`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateTaskOrder = (taskOrders) => {
  const url = `/task/order/update`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, { taskOrders })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

// Task Comments API
export const getTaskComments = (taskId) => {
  const url = `/task/${taskId}/comments`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const addTaskComment = (taskId, comment, parentCommentId = null) => {
  const url = `/task/${taskId}/comments`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, { comment, parentCommentId })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateTaskComment = (commentId, comment) => {
  const url = `/task/comments/${commentId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, { comment })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteTaskComment = (commentId) => {
  const url = `/task/comments/${commentId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};